import type { SseMessage } from "../contracts";

export interface SseParseResult {
    messages: SseMessage[];
    rest: string;
}

// Parse a growing SSE text buffer into complete messages, returning the unparsed
// remainder. Pure function — the SseClient feeds it decoded chunks; tests feed it
// strings. Handles CRLF, comment lines (":"), multi-line data, and JSON payloads.
export function parseSseBuffer(buffer: string): SseParseResult {
    let rest = buffer.replace(/\r\n/g, "\n");
    const messages: SseMessage[] = [];
    let sep = rest.indexOf("\n\n");
    while (sep !== -1) {
        const block = rest.slice(0, sep);
        rest = rest.slice(sep + 2);
        const message = parseBlock(block);
        if (message) messages.push(message);
        sep = rest.indexOf("\n\n");
    }
    return { messages, rest };
}

function parseBlock(block: string): SseMessage | null {
    let name = "message";
    const dataLines: string[] = [];
    for (const line of block.split("\n")) {
        if (line === "" || line.startsWith(":")) continue;
        const colon = line.indexOf(":");
        const field = colon === -1 ? line : line.slice(0, colon);
        let value = colon === -1 ? "" : line.slice(colon + 1);
        if (value.startsWith(" ")) value = value.slice(1);
        if (field === "event") name = value;
        else if (field === "data") dataLines.push(value);
    }
    if (dataLines.length === 0) return null;
    const raw = dataLines.join("\n");
    let payload: SseMessage["payload"];
    try {
        payload = JSON.parse(raw);
    } catch {
        payload = raw;
    }
    return { name, payload };
}
